import {Constants} from '../constants/constants';

export class NumberConverter {

  /**
   * Method: For correct calculation round number for float numeric (default 0 digits after comma)
   * @param value
   * @param digitsAfterComma
   */
  public static roundNumber(value: number, digitsAfterComma?: number): string {
    return (Math.round((+value + Number.EPSILON) * 100) / 100).toFixed(digitsAfterComma ?? 0);
  }

  /**
   * Method: Add apostrophe every tree numbers
   * @param value
   */
  public static pasteApostropheAfterEachThreeNums(value: number): string {
    if (!!value && value?.toString().length && !Number.isNaN(+value)) {
      const numArr = value.toString().split(Constants.DOT);
      if (numArr[0]) {
        numArr[0] = NumberConverter.groupThousands(numArr[0]);
      }
      return numArr.join();
    }
    return '';
  }

  /**
   * Method: Format number with fixed decimal digits and apostrophe-grouped integer part
   * @param value
   * @param digits
   */
  public static pasteApostropheWithFixedDecimals(value: number, digits: number = 2): string {
    const [integerPart, decimalPart] = value.toFixed(digits).split(Constants.DOT);
    const groupedIntegerPart = NumberConverter.groupThousands(integerPart);
    return decimalPart ? `${groupedIntegerPart}${Constants.DOT}${decimalPart}` : groupedIntegerPart;
  }

  /**
   * Method: Group integer part digits by three with apostrophe separator
   * @param integerPart
   */
  private static groupThousands(integerPart: string): string {
    return (integerPart.match(/-?\d{1,3}(?=(\d{3})*$)/g) ?? [integerPart]).join(Constants.APOSTROPHE);
  }

}
